<template>
  <div v-if="hasTechnicalSpecification || hasDescription" id="productInfoTabs" class="container-lg">
    <div class="tabs">
      <div class="tabs__nav">
        <button
            v-if="hasTechnicalSpecification"
            :class="{ 'tabs__nav-item': true, 'active': activeTab === 'technical' }"
            data-tab="#productSpecTab"
            data-tab-for="#productInfoTabs"
            type="button"
            @click="changeActiveTab('technical')"
        >
          {{ in18['page_product_technical_specification'] }}
        </button>
        <button
            v-if="hasDescription"
            :class="{ 'tabs__nav-item': true, 'active': activeTab === 'description' }"
            class="tabs__nav-item"
            data-tab="#productDescriptionTab"
            data-tab-for="#productInfoTabs"
            type="button"
            @click="changeActiveTab('description')"
        >
          {{ in18['page_product_description'] }}
        </button>
      </div>
      <div class="tabs__content">
        <div :class="{ 'jsTabItem': true, 'hide': activeTab !== 'technical' }"
             id="productSpecTab">
          <div class="row">
            <div class="col-lg-6">
              <template
                  v-for="group in product.property_groups.slice(0, Math.ceil(product.property_groups.length / 2))">
                <h3 class="tabs__title fw-500">
                  {{ group.group_name }}
                </h3>
                <table class="tabs__table">
                  <tr v-for="(property, propIndex) in group.properties" :key="propIndex">
                    <td>{{ property.property_title }}</td>
                    <td class="text-dark fw-500">{{ property.selected_option_value }}</td>
                  </tr>
                </table>
              </template>
            </div><!-- /.col -->
            <div class="col-lg-6">
              <template v-for="group in product.property_groups.slice(Math.ceil(product.property_groups.length / 2))">
                <h3 class="tabs__title fw-500">
                  {{ group.group_name }}
                </h3>
                <table class="tabs__table">
                  <tr v-for="(property, propIndex) in group.properties" :key="propIndex">
                    <td>{{ property.property_title }}</td>
                    <td class="text-dark fw-500">{{ property.selected_option_value }}</td>
                  </tr>
                </table>
              </template>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.jsTabItem -->
        <div :class="{ 'jsTabItem': true, 'hide': activeTab !== 'description' }"
             id="productDescriptionTab">
          <div class="revert" v-html="product.description"/>
        </div>
      </div>
    </div>
  </div>

  <div class="container-lg">
    <hr>
  </div>
</template>

<script>
export default {
  name:  'ProductInfoTabs',
  props: {
    product: Object,
    in18:    {
      type: Object,
    },
  },
  data() {
    return {
      activeTab: this.setActiveTab(),
    };
  },
  computed: {
    hasTechnicalSpecification() {
      return this.product.property_groups && this.product.property_groups.length > 0;
    },
    hasDescription() {
      return this.product.description && this.product.description.trim() !== '';
    },
  },
  methods:  {
    setActiveTab() {
      if (this.product.property_groups && this.product.property_groups.length > 0) {
        return 'technical';
      }
      return 'description';
    },
    changeActiveTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>
